import actionConsts from 'constants/actions';

const initialState = [];

const domains = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.INIT_GAME_DATA:
            return action.payload.domains;
        default:
            return state;
    }
};

export default domains;